import { createBrowserHistory } from 'history';
import { DEFAULT_BASENAME } from 'containers/App/constants';
const history = createBrowserHistory({
  basename: DEFAULT_BASENAME,
});
export default history;
